import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customMask'
})
export class MyCustomMaskPipe implements PipeTransform {

    transform(value: any, args?: string): any {
        var _maskSpecialCharacters = ['/', '(', ')', '.', ':', '-', ' ', '+'];
        var _maskAwaliablePatterns = {
            '0': /\d/,
            '9': /\d/,
            'A': /[a-zA-Z0-9]/,
            'S': /[a-zA-Z]/
        };
        if (value === undefined || value === null) {
            return '';
        }
        var cursor = 0;
        var result = '';
        var inputArray = value.toString().split('');
        // tslint:disable-next-line
        for (var i = 0, inputSymbol = inputArray[0]; i
            < inputArray.length; i++ , inputSymbol = inputArray[i]) {
            if (result.length === args.length) {
                break;
            }
            var maskSymbol = args[cursor]
            if (inputSymbol === maskSymbol
                || _maskAwaliablePatterns[maskSymbol]
                && _maskAwaliablePatterns[maskSymbol].test(inputSymbol)) {

                result += inputSymbol;
                cursor++;
            }
            else if (_maskSpecialCharacters.indexOf(args[cursor]) !== -1) {
                result += args[cursor];
                cursor++;
                i--;
            }
            else if (args[cursor] === '9') {
                cursor++;
                i--;
            }
        }
        if (result.length + 1 === args.length
            && _maskSpecialCharacters.indexOf(args[args.length - 1]) !== -1) {
            result += args[args.length - 1];
        }
        return result;
    }





}
